import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Role } from 'src/app/models';
import { AuthGuard } from 'src/app/services/auth/auth-guard';
import { ItauDashboardComponent } from './itau-dashboard/itau-dashboard.component';
import { SchedulerJobsComponent } from './scheduler-jobs/scheduler-jobs.component';
import { TaxPriceComponent } from './tax-price/tax-price.component';
import { BillingControlComponent } from './billing-control/billing-control.component';
import { BillingCycleComponent } from './billing-cycle/billing-cycle.component';
import { BillingMonthComponent } from './billing-month/billing-month.component';
import { ReprocessamentosComponent } from './reprocessamentos/reprocessamentos.component';

const routes: Routes = [
  { path: 'tax-price', component: TaxPriceComponent },
  { path: 'reprocessamentos', component: ReprocessamentosComponent },
  {
    path: 'itau-dashboard',
    component: ItauDashboardComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  },
  {
    path: 'scheduler-jobs',
    component: SchedulerJobsComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  },
  {
    path: 'billing-control',
    component: BillingControlComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  },
  {
    path: 'billing-cycle',
    component: BillingCycleComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  },
  {
    path: 'billing-month',
    component: BillingMonthComponent,
    canActivate: [
      () =>
        inject(AuthGuard).canActivate() &&
        inject(AuthGuard).canActivatePermissions([Role.Full_Administrator])
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancialRoutingModule {}
